// SPDX-License-Identifier: AGPL-3.0-or-later

import {DebugModal, type DebugTab} from '@app/features/devtools/components/debug/DebugModal';
import type {Guild} from '@app/features/guild/models/Guild';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useMemo} from 'react';

interface GuildDebugModalProps {
	title: string;
	guild: Guild;
}
export const GuildDebugModal: React.FC<GuildDebugModalProps> = observer(({title, guild}) => {
	const {t} = useLingui();
	const recordJsonData = useMemo(() => guild.toJSON(), [guild]);
	const tabs: Array<DebugTab> = [
		{
			id: 'record',
			label: t`Community Record`,
			data: recordJsonData,
		},
	];
	return <DebugModal title={title} tabs={tabs} />;
});
